// For Work in progress
export const steps = [
  "Casing",
  "Boring",
  "Top Middle Cage Lapping",
  "Bottom Middle Cage Lapping",
  "Tremie Lowering",
  "Concreting",
  "Pile Forecasting",
  "Area Cleaning",
];

export const stepDetails = [
  { label: "Step Work Started on", value: "15-08-2022" },
  { label: "Step Work Completed on", value: "15-08-2022" },
  { label: "Machine Used", value: "KA01AS6353" },
  { label: "Step Work Started by", value: "Mr Ramesh Kumar" },
  { label: "Step Work Completed by", value: "Mr Ramesh Kumar" },
  { label: "Completion Status", value: "Completed with Delay" },
  { label: "Delay Period", value: "6Hrs" },
  { label: "Reasonable Agency", value: "15-08-2022" },
  { label: "Delay Reason", value: "Truck came Late" },
];

export const engineerDetails = [
  { label: "Engineer Name" },
  { label: "Employee Id" },
  {
    label: "Steps Started",
  },
  {
    label: "Steps Completed",
  },
];
